// src/components/ProjectsShowcaseHome.jsx
import React from "react";
import styled from "styled-components";
import { gradients } from "../theme/theme";

const Section = styled.section`
  background: ${gradients.heroBackground};
  color: #fff;
  padding: 4rem 2rem;
`;

const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SliderViewport = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1.5rem;
  padding-bottom: 1rem;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Card = styled.div`
  flex: 0 0 300px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.05),
    rgba(255, 255, 255, 0.02)
  );
  border-radius: 16px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  scroll-snap-align: start;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-6px) scale(1.03);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
  }
`;

const ProjectTitle = styled.h3`
  font-size: 1.2rem;
  color: #00d4ff;
`;

const ProjectDesc = styled.p`
  font-size: 0.95rem;
  margin: 0.8rem 0 1rem;
  color: #ccc;
  line-height: 1.5;
`;

const CTA = styled.a`
  display: inline-block;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.05);
  }
`;

const ViewAllCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: linear-gradient(90deg, #ff7a18, #ff0066);
    transform: scale(1.05);
  }
`;

export default function ProjectsShowcaseHome() {
  const projectData = [
    {
      title: "DealDome - Classified App",
      description:
        "A modern classified app for buying & selling products with filters, real-time chat, and secure payments.",
      link: "https://dealdome.com/",
    },
    {
      title: "Cinystore",
      description:
        "A social media app for film enthusiasts! Producers share their latest movie info directly with audience.",
      link: "https://apps.apple.com/in/app/cinystore/id6473719567",
    },
    {
      title: "HiresGulf - Jobs Portal",
      description:
        "Mobile-first job portal connecting Gulf employers with skilled professionals.",
      link: "https://play.google.com/store/apps/details?id=com.horizoncandidateapp&hl=en_IN",
    },
  ];

  return (
    <Section>
      <Title>🚀 Featured Projects</Title>

      <SliderViewport>
        {projectData.map((p, i) => (
          <Card key={i}>
            <ProjectTitle>{p.title}</ProjectTitle>
            <ProjectDesc>{p.description}</ProjectDesc>
            <CTA href={p.link} target="_blank" rel="noopener noreferrer">
              View Project
            </CTA>
          </Card>
        ))}

        {/* Last card → View All Projects */}
        <ViewAllCard as="a" href="/projects">
          View All Projects →
        </ViewAllCard>
      </SliderViewport>
    </Section>
  );
}
